import _ from 'lodash';
import angular from 'angular';

const StoreServiceFactory = (NewBackendService, endPoints, Environment, $q, $timeout, FoundationApi, ModalFactory, StorageService) => {
  'ngInject';
  
  var storeList = []

  const service = {

        getBusinesses: () => $q((resolve, reject) => {
            let businesses = angular.fromJson(StorageService.getLocalStorage('businesses'));
            if (businesses) {
                resolve(businesses);
                return;
            }
            NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/users/me/businesses`).then(res => {
                console.log(res);
                if(res.data._embedded && res.data._embedded.businesses.length > 0){
                    let businesses = res.data._embedded.businesses;
                    StorageService.setLocalStorageObject('businesses', businesses);
                    const currentWallet = StorageService.getLocalStorageObject('currentWallet'); 
                    if (!currentWallet) {
                        StorageService.setLocalStorageObject('currentWallet', businesses[0].wallet.id); 
                    }
                }
                resolve(businesses);
            }, (err) => {
                reject(err);
            });
        }),
    
        getStoreList: () => $q((resolve, reject) => {
            var merchantProfile = angular.fromJson(StorageService.getLocalStorage('userContext'));
            NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/businesses/${merchantProfile.business.id}/shops`, {"page": 0, "size": 1000}).then(res => {
                if(res.data._embedded && res.data._embedded.shops.length > 0){
                    storeList = _.map(res.data._embedded.shops, store => {
                        store.address = store.street + " " + store.streetNumber + ", " + store.city + ", " + store.province + " " + store.postalCode
                        return store;
                    })
                    StorageService.setLocalStorageObject('storeList', storeList)
                    resolve(storeList);
                }else{
                    resolve ([])
                }
            })    
        }),

        saveNewStore: (store) => $q((resolve, reject) => {
            var merchantProfile = angular.fromJson(StorageService.getLocalStorage('userContext'));
            NewBackendService.invokeWebApiPost(`${endPoints.userUrl}/businesses/${merchantProfile.business.id}/shops`, store).then(res => {
                resolve(res);
            })    
        }),

        deleteStore: (id) => $q((resolve, reject) => {
            NewBackendService.invokeWebApiDelete(`${endPoints.userUrl}/businesses/shops/${id}`).then(res => {
                resolve(res);
            });    
        }),

        getSavedStoreList: () => {
            return StorageService.getLocalStorageObject('storeList') ? StorageService.getLocalStorageObject('storeList') : []
        },

        getSelectedStore: () => {
            
            return StorageService.getLocalStorageObject('selectedStore');    
        },

        setSelectedStore: (store) => {
            StorageService.setLocalStorageObject('selectedStore', store)
        },

        clean: () => {
            StorageService.clearLocalStorage("selectedStore")
            StorageService.clearLocalStorage("storeList")
        } 

    }

  return service;
}

export default StoreServiceFactory;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/store.factory.js
 **/